export const customerCardPanelTitleTypographyProps = {
  sx: { fontSize: "1rem", fontWeight: 700 },
};

export const customerCardPanelLabelSx = {
  fontSize: "0.875rem",
  lineHeight: 1.5,
  fontWeight: 600,
};

export const customerCardPanelValueSx = {
  fontSize: "0.875rem",
  lineHeight: 1.5,
  wordBreak: "break-word",
};

/** Shared CardHeader layout so dividers align across dashboard panels. */
export const customerCardPanelHeaderSx = {
  py: 1,
  px: 2,
  minHeight: 56,
  alignItems: "center",
  boxSizing: "border-box",
  "& .MuiCardHeader-content": { my: 0 },
  "& .MuiCardHeader-action": {
    m: 0,
    alignSelf: "center",
  },
};
